function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

window.scrollToTop = scrollToTop;
